angular
  .module('capability-ng-scheduler')
  .directive(
    'eabCommitmentRange',
    function eabCommitmentRange(
      CommitmentRangesEnum,
      loadTermCommitmentPreferencesCommand,
      saveTermCommitmentPreferencesCommand,
      ngPreferencesCommitmentModel,
      preferencesSummaryDelegate
    ) {
      'use strict';

      return {
        replace: true,
        templateUrl:
          'capability-ng-scheduler/src/views/components/preferences/components/commitment_range/commitment_range.html',
        scope: {
          termId: '=eabCommitmentRange',
          rangeEnum: '='
        },
        controller: function ($scope) {
          $scope.value = $scope.rangeEnum.value.min;

          $scope.updateInput = function (event) {
            if (event) {
              $scope.value = event.target.value;
            }
            if (!$scope.value && !_.isFinite($scope.value)) {
              $scope.value = 0;
            }
            $scope.value = parseInt($scope.value, 10);
            $scope.textValue = $scope.value;
          };

          loadTermCommitmentPreferencesCommand($scope.termId, $scope.rangeEnum.id).then(function (commitment) {
            $scope.value = commitment.commitment_value;
            $scope.updateInput();
            $scope.textValue = $scope.value.toString();
            ngPreferencesCommitmentModel.write({ id: $scope.rangeEnum.id, value: $scope.value });
            preferencesSummaryDelegate.setCommitment({ id: $scope.rangeEnum.id, value: $scope.value });
          });

          var saveMe = _.debounce(function () {
            ngPreferencesCommitmentModel.write({ id: $scope.rangeEnum.id, value: $scope.value });
            preferencesSummaryDelegate.setCommitment({ id: $scope.rangeEnum.id, value: $scope.value });
            saveTermCommitmentPreferencesCommand($scope.termId, $scope.rangeEnum.id, parseInt($scope.value));
          }, 500);

          $scope.onCommitValue = function () {
            $scope.updateInput();
            saveMe();
          };

          $scope.models = {
            id: 'slider-' + $scope.termId,
            options: {
              floor: $scope.rangeEnum.value.min,
              ceil: $scope.rangeEnum.value.max,
              step: 1,
              getSelectionBarColor: function (value) {
                return '#f28b00';
              },
              onChange: function (id) {
                $scope.updateInput();
              },
              onEnd: function (id) {
                $scope.updateInput();
                saveMe();
              }
            }
          };
        }
      };
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/components/commitment_range/commitment_range.js